import * as apiWarehouse from 'api/apiWarehouses';
import type { PriceSaleBatchItem } from '@econtractor/types';

export interface ApplyProposalSalePriceItem {
    productId: number;
    priceSale: number;
    fromWarehouseId: number;
    count: number;
}

/**
 * Після transfer одним запитом проставляє роздрібні ціни з КП
 * на прихідні операції складу об'єкта (закупівельну не змінює).
 */
export const applyProposalSalePricesBatch = async (
    objectWarehouseId: number,
    items: ApplyProposalSalePriceItem[],
    description?: string,
): Promise<boolean> => {
    if (!(objectWarehouseId > 0) || !items?.length) {
        return false;
    }

    const batchItems: PriceSaleBatchItem[] = items
        .filter(
            (item) =>
                Number(item.productId) > 0 &&
                Number(item.count) > 0 &&
                Number(item.fromWarehouseId) > 0,
        )
        .map((item) => ({
            productId: Number(item.productId),
            priceSale: Number(item.priceSale) || 0,
            fromWarehouseId: Number(item.fromWarehouseId),
            count: Number(item.count),
        }));

    if (!batchItems.length) return false;

    const res = await apiWarehouse.setPriceSaleBatch(objectWarehouseId, {
        items: batchItems,
        description: description || '',
    });

    if (!res) return false;
    return Boolean(res.stat) && !(Number(res.failed) > 0);
};
